import React, { useEffect } from 'react';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import { MfeLoad } from '@carvana/microfrontend';

const renderLocation = 'support-center';

export const ContactFlowModule = ({ isContactUsExperiment = false }) => {
  useEffect(() => {
    MfeLoad({
      globals: {
        axios: () => import('axios'),
        styledComponents: () => import('styled-components'),
        nanoid: () => import('nanoid')
      },
      files: [
        [
          'ContactFlowModule',
          [
            {
              component: 'default',
              browser: true,
              default: {
                file: 'main.js',
                manifest: `${process.env.GATSBY_CDN_BASE_URL}/contact-flow-module/manifest.json`
              }
            }
          ]
        ]
      ]
    });
  }, []);

  return (
    <MfeReactComponent
      module="ContactFlowModule"
      component="default"
      renderLocation={renderLocation}
      isContactUsExperiment={isContactUsExperiment}
    />
  );
};
